import { IdAtendimento, IdUsuario, IdUsuarioAtendimento } from "../common-types";
import { GenericService } from "../generic-service";

export type CreateUsuarioAtendimento = {
  idUsuario    : IdUsuario;
  idAtendimento: IdAtendimento;
}

export type UpdateUsuarioAtendimento = Partial<CreateUsuarioAtendimento> & { id: IdUsuarioAtendimento }

export type ResponseUsuarioAtendimento = {
  id: IdUsuarioAtendimento;
  idUsuario    : IdUsuario;
  idAtendimento: IdAtendimento;
}

export class UsuarioAtendimentoService extends GenericService<CreateUsuarioAtendimento, UpdateUsuarioAtendimento, ResponseUsuarioAtendimento> {     
  constructor() { super('usuarios-atendimentos') }
  async getByAtendimento(idAtendimento: IdAtendimento) {
    return await this.f.get(`/atendimento/${idAtendimento}`, undefined, {resolve404As: [], resolve404AsValue: true}) as ResponseUsuarioAtendimento[]
  }
}